import { checkIsInternalCompany } from 'app/auth/authUtils';
import { createSelector } from 'reselect';

import { getIsFromInternalCompany } from 'store/auth/selectors';

import { getSystem } from './system.selectors';

const selectCicLoanTermReasonsState = createSelector(
  getSystem,
  ({ cicLoanTermReasons }) => cicLoanTermReasons,
);

export const selectCicLoanTermReasons = createSelector(
  [selectCicLoanTermReasonsState, getIsFromInternalCompany],
  (reasons, isInternalCompany) =>
    reasons.map(reason => ({
      ...reason,
      isGlobal: !isInternalCompany && checkIsInternalCompany(reason),
    })),
);
